"use client";

import React from "react";
import styles from "@/components/Offers/Offers.module.scss";
import SingleOfferCard from "./SingleOfferCard/SingleOfferCard";

type OffersProps = {
  showButton: boolean;
  offers: any;
};

const Offers = ({ showButton, offers }: OffersProps) => {
  return (
    <div className="container px-[20px] p-6 rounded-lg">
      <div className="grid grid-cols-1 gap-6 mt-10">
        {offers.map((offer: any) => {
          return <SingleOfferCard data={offer} key={offer.id} />;
        })}

        <div className="flex justify-center mt-8">
          {showButton && (
            <button className={styles.button}>View All Offers</button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Offers;
